<script setup lang="ts">
    import { ref } from 'vue';
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    import axios from 'axios';

    const props = defineProps(['question', 'no', 'name']);

    const isFeedbackShown = ref(false);
    const isLoading = ref(false);
    const phone = ref(null);
    const phoneUpdateInfoMessage = ref('');

    function register() {
        let inputPhoneValue = '0' + phone.value.inputmask.unmaskedvalue();

        if (inputPhoneValue === '0') {
            phoneUpdateInfoMessage.value = 'Telefon numaranızı giriniz';
            phone.value.focus();
            return;
        }

        if (!isValidPhoneNumber(inputPhoneValue)) {
            phoneUpdateInfoMessage.value = 'Hatalı numara girdiniz';
            phone.value.focus();
            return;
        }

        isLoading.value = true;

        axios.post('/profil/telefon-dogrulama/onay-kodu-gonder', {
            name: props.name,
            phone: inputPhoneValue,
        }).then(response => {
            if (response.data.error === '') {
                isFeedbackShown.value = true;
            } else {
                phoneUpdateInfoMessage.value = response.data.error;
            }
        }).catch(e => {
            if (!e.response) {
                phoneUpdateInfoMessage.value = 'Lütfen internet bağlantınızı kontrol ediniz!';
            } else {
                phoneUpdateInfoMessage.value = 'Telefon numaranız gönderilemedi lütfen tekrar deneyiniz!';
            }
        }).then(() => {
            isLoading.value = false;
        });
    }

    const isValidPhoneNumber = (phoneValue) => {
        return phoneValue.length === 11 && phoneValue.indexOf('05') === 0;
    }
</script>

<template>
    <div class="h-full">
        <div v-if="isFeedbackShown === false">
            <h3 v-html="props.question.title"></h3>
            <div v-html="props.question.description"></div>

            <div>
                <input type="tel" class="w-full lg:w-64 form-control focus:border-primary mt-4" ref="phone" v-mask="'0 (999) 999 99 99'"
                       tabindex="0"  @keyup.enter="showFeedback" placeholder="Lütfen telefon numaranızı giriniz" />
            </div>
            <div class="text-secondary text-xs mt-1">
                {{ phoneUpdateInfoMessage }}
            </div>

            <button class="btn btn-primary mt-8" @click="register">Devam Et</button>
        </div>
        <div v-else>
            <img src="https://cdn.pixabay.com/animation/2023/12/09/19/16/19-16-42-998_512.gif" class="w-64" />
            <div class="font-bold mt-4" v-html="props.question.feedbackText"></div>

            <a href="/kayit?ogrenci" class="btn btn-primary mt-8">Derslig Pro'yu Ücretsiz Dene</a>
        </div>
        <div v-show="isLoading" class="absolute w-full h-full top-1/2 left-1/2 text-center bg-black bg-opacity-10 z-10" style="transform: translate(-50%,-50%)">
            <div class="w-full h-full flex items-center justify-center">
                <pulse-loader :color="'#03B0B9'" :size="'12px'"></pulse-loader>
            </div>
        </div>
    </div>

</template>

<style scoped>

</style>
